module.exports = __webpack_public_path__ + "img/Edit-User-Pen.3aa93901.svg";